import { render } from "./AddTyreSize.vue?vue&type=template&id=a3087b4e"
import script from "./AddTyreSize.vue?vue&type=script&lang=js"
export * from "./AddTyreSize.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__